import { ClarityUnmaskDirective } from 'app/shared/directives/clarity-unmask.directive';
import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Router, RouterLink } from '@angular/router';
import { Company } from '@interfaces/Company';
import { AccountService } from '@service-features/account.service';
import { AuthService } from '@service-features/auth.service';
import { CustomModalComponent } from '@shared-components/custom-modal/custom-modal.component';
import { NotificationsBadgeComponent } from '@shared-components/notifications-badge/notifications-badge.component';
import { SidebarService } from '@shared-services/sidebar.service';
import { PermissionsService } from '@shared-services/permissions.service';
import { ACCOUNT_SETTINGS_PERMISSIONS } from '../../../core/permissions/navigation';

@Component({
  selector: 'gd-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: true,
  imports: [
    ClarityUnmaskDirective,
    MatIconModule,
    NotificationsBadgeComponent,
    MatButtonModule,
    MatDividerModule,
    MatMenuModule,
    MatTooltipModule,
    CommonModule,
    RouterLink,
  ],
})
export class HeaderComponent {
  constructor(
    private authService: AuthService,
    private accountService: AccountService,
    private router: Router,
    private matDialog: MatDialog,
    private sidebarService: SidebarService,
    private permissions: PermissionsService,
  ) {}

  toggleMobileNavigation(): void {
    this.sidebarService.toggleMobileNavigation();
  }

  get isMobileNavigationOpen(): boolean {
    return this.sidebarService.isMobileNavigationOpen;
  }

  get getUserData() {
    return this.accountService.userData;
  }

  /** Where the logo leads: the landing of the session (Inicio or Tablero). */
  get landingUrl(): string {
    return this.permissions.landingUrl;
  }

  /** Owner-only area: "Configuración del taller". */
  get canOpenSettings(): boolean {
    return this.permissions.canAny(ACCOUNT_SETTINGS_PERMISSIONS);
  }

  get getCompanyData(): Company {
    const companyRaw = localStorage.getItem('company');
    if (!companyRaw) return {} as Company;

    const company = JSON.parse(companyRaw);
    company.createdAt = new Date(company.createdAt);
    return company;
  }

  logout(): void {
    const modalData = {
      title: 'Cerrar sesión',
      message: `¿Querés cerrar la sesión?`,
      rejectText: 'No',
      acceptText: 'Si',
    };
    this.matDialog
      .open(CustomModalComponent, { data: modalData })
      .afterClosed()
      .subscribe((confirmation: boolean) => {
        if (confirmation) {
          this.authService.onLogout();
        }
      });
  }

  navigateToSettings(): void {
    void this.router.navigate(['/account-settings']);
  }

  navigateToMyAccount(): void {
    void this.router.navigate(['/my-account']);
  }

  navigateToHelp(): void {
    void this.router.navigate(['/help'], {
      queryParams: { source: 'header' },
    });
  }
}
